import * as authApi from "../views/authentication/auth-api"
import * as appApi from '../views/app/app-api'

const AuthApi = authApi
const AppApi = appApi

export { AuthApi, AppApi }
